export const CLEAR_ALERT = 'CLEAR_ALERT';
export const CLEAR_SONG_TIMELINE = 'CLEAR_SONG_TIMELINE';
export const DELETE_ARTIST_PICK = 'DELETE_ARTIST_PICK';
export const FETCH_ARTIST_HISTORY = 'FETCH_ARTIST_HISTORY';
export const FETCH_CONCERT_VIEW = 'FETCH_CONCERT_VIEW';
export const LOAD_ACTIVATE_ANNOUNCEMENTS = 'LOAD_ACTIVATE_ANNOUNCEMENTS';
export const LOAD_ANNOUNCEMENTS = 'LOAD_ANNOUNCEMENTS';
export const LOAD_ARTIST_IDENTITY = 'LOAD_ARTIST_IDENTITY';
export const LOAD_AUDIENCE_ANNOTATIONS = 'LOAD_AUDIENCE_ANNOTATIONS';
export const LOAD_AUDIENCE_ARTIST_OVERVIEW = 'LOAD_AUDIENCE_ARTIST_OVERVIEW';
export const LOAD_AUDIENCE_TIMELINE = 'LOAD_AUDIENCE_TIMELINE';
export const LOAD_CURRENT_SONG = 'LOAD_CURRENT_SONG';
export const LOAD_IDENTITY_ANNOUNCEMENTS = 'LOAD_IDENTITY_ANNOUNCEMENTS';
export const LOAD_SONG_AGGREGATE = 'LOAD_SONG_AGGREGATE';
export const LOAD_SONG_ANNOTATIONS = 'LOAD_SONG_ANNOTATIONS';
export const LOAD_SONG_DISCOVERY = 'LOAD_SONG_DISCOVERY';
export const LOAD_SONG_LOCATIONS = 'LOAD_SONG_LOCATIONS';
export const LOAD_SONG_PLAYLISTS = 'LOAD_SONG_PLAYLISTS';
export const LOAD_SONG_SOURCES = 'LOAD_SONG_SOURCES';
export const LOAD_SONG_TIMELINE = 'LOAD_SONG_TIMELINE';
export const LOAD_SONG_TOP_CITIES = 'LOAD_SONG_TOP_CITIES';
export const LOAD_TOP_TRACKS = 'LOAD_TOP_TRACKS';
export const MORE_ARTIST_HISTORY = 'MORE_ARTIST_HISTORY';
export const SAVE_ARTIST_PICK_V2 = 'SAVE_ARTIST_PICK_V2';
export const SAVE_BIO = 'SAVE_BIO';
export const SET_ALERT = 'SET_ALERT';
export const SET_PLATFORM = 'SET_PLATFORM';
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const UNLOAD_CURRENT_ARTIST = 'UNLOAD_CURRENT_ARTIST';
export const UNLOAD_CURRENT_SONG = 'UNLOAD_CURRENT_SONG';
export const UPDATE_ACTIVATE_ANNOUNCEMENTS = 'UPDATE_ACTIVATE_ANNOUNCEMENTS';
export const UPDATE_ANNOUNCEMENTS = 'UPDATE_ANNOUNCEMENTS';
export const UPDATE_ARTISTS_PLAYLISTS = 'UPDATE_ARTISTS_PLAYLISTS';
export const UPDATE_GALLERY_IMAGES = 'UPDATE_GALLERY_IMAGES';
export const UPDATE_HEADER_IMAGE = 'UPDATE_HEADER_IMAGE';
export const UPDATE_IDENTITY_ANNOUNCEMENTS = 'UPDATE_IDENTITY_ANNOUNCEMENTS';
export const UPDATE_SOCIAL_LINKS = 'UPDATE_SOCIAL_LINKS';
